// Add every JS inside the dom content
document.addEventListener("DOMContentLoaded", () => {
  // Product Details Tab
  var app = {};
  app.tabs = (function () {
    var module = {};
    module.init = function () {
      var $tabLink = $(".tabs__link");
      var $tabAreas = $(".tabs__area");
      var $tabList = $(".tabs__list");
      $tabList.addClass("tabs__list--open");
      var tabSwitcher = function () {
        $tabLink.off("click").on("click", function (e) {
          var currentAttrValue = $(this).attr("href");
          $(currentAttrValue)
            .addClass("tabs__area--active")
            .siblings(".tabs__area")
            .removeClass("tabs__area--active");
          $(this)
            .parent("li")
            .addClass("tabs__item--active")
            .siblings()
            .removeClass("tabs__item--active");

          e.preventDefault();
        });
      };
      tabSwitcher();
    };
    return module;
  })();
  app.tabs.init();

  // Product Details Tab FAQ Accrodian
  const togglers = document.querySelectorAll("[data-toggle]");

  togglers.forEach((btn) => {
    btn.addEventListener("click", (e) => toggleFAQ(e));
    btn.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
        e.preventDefault();
        toggleFAQ(e);
      }
    });
  });

  function toggleFAQ(e) {
    const btn = e.currentTarget;
    const selector = btn.dataset.toggle;
    const block = document.querySelector(`${selector}`);

    togglers.forEach((otherBtn) => {
      const otherSelector = otherBtn.dataset.toggle;
      const otherBlock = document.querySelector(`${otherSelector}`);
      if (otherBtn !== btn) {
        otherBtn.classList.remove("active");
        otherBlock.style.maxHeight = "";
        otherBtn.setAttribute("aria-expanded", "false");
      }
    });

    if (btn.classList.contains("active")) {
      block.style.maxHeight = "";
      btn.setAttribute("aria-expanded", "false");
    } else {
      block.style.maxHeight = block.scrollHeight + "px";
      btn.setAttribute("aria-expanded", "true");
    }

    btn.classList.toggle("active");
  }

  // About US Testimonials slider
  var swiper = new Swiper(".ctm-testimonial-slider .testimonial-slider", {
    slidesPerView: 2,
    spaceBetween: 19,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        loop: true,
      },
      768: {
        slidesPerView: 2,
        loop: true,
      },
    },
  });

  //PDP Sound Test
  const video = document.getElementById("soundVideo");
  const playButton = document.getElementById("sound_playButton");
  const pauseButton = document.getElementById("sound_pauseButton");

  if (video) {
    function updateButtons() {
      if (video.paused || video.ended) {
        playButton.style.display = "flex";
        pauseButton.style.display = "none";
      } else {
        playButton.style.display = "none";
        pauseButton.style.display = "flex";
      }
    }

    playButton?.addEventListener("click", () => {
      video.play();
    });

    pauseButton?.addEventListener("click", () => {
      video.pause();
    });

    video.addEventListener("play", updateButtons);
    video.addEventListener("pause", updateButtons);

    updateButtons();
  }

  // PDP video play and pause JS
  document.querySelectorAll(".video-wrapper").forEach((wrapper) => {
    const video = wrapper.querySelector("video");
    const playButton = wrapper.querySelector(".play-gif");

    function togglePlay() {
      if (video.paused || video.ended) {
        video.play();
      } else {
        video.pause();
      }
    }

    playButton.addEventListener("click", togglePlay);
    video.addEventListener("playing", () => {
      playButton.style.opacity = 0;
    });
    video.addEventListener("pause", () => {
      playButton.style.opacity = 1;
    });
    video.addEventListener("click", togglePlay);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const closeBtns = document.querySelectorAll(".mega-menu-close-btn");

  closeBtns.forEach((closeBtn) => {
    closeBtn.addEventListener("click", function () {
      const parentDetails = closeBtn.closest("details"); // Finds the closest <details> element

      if (parentDetails) {
        parentDetails.removeAttribute("open"); // Removes the 'open' attribute
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".ctm-slider"); // Select all sliders

  sliders.forEach((slider) => {
    const dots = slider.nextElementSibling.querySelectorAll(".slider-dot"); // Assume dots are in the next sibling of the slider

    // Function to update active dot for the current slider
    function updateDots(activeIndex) {
      dots.forEach((dot, index) => {
        dot.classList.toggle("is-active", index === activeIndex);
      });
    }

    // Event listener for slider scroll
    slider.addEventListener("scroll", () => {
      const slideWidth = slider.offsetWidth;
      const currentIndex = Math.round(slider.scrollLeft / slideWidth);
      updateDots(currentIndex);
    });

    // Add click listeners to dots
    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        slider.scrollTo({
          left: slider.offsetWidth * index,
          behavior: "smooth",
        });
        updateDots(index);
      });
    });
  });
});

// blog-slider

var swiper = new Swiper(".ctm-home-blogs .swiper", {
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  slidesPerView: 1,
  spaceBetween: 20,
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 2,
    },
  },
});
var swiper = new Swiper(".ctm-pdp-blogs .swiper", {
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  slidesPerView: 1,
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1280: {
      slidesPerView: 2,
      spaceBetween: 116,
    },
  },
});

//blog-slider-ends
